<ng-select *ngIf="!image" [items]="items" [bindLabel]="labelProperty" [bindValue]="valueProperty" [multiple]="multiple"
    [placeholder]="placeholder" [clearable]="clearable" [formControl]="control" [searchable]="searchable" [closeOnSelect]="!multiple"
    (change)="onChange($event)" (search)="onSearch($event)">
</ng-select>

<ng-select *ngIf="image" [items]="items" [bindLabel]="labelProperty" [bindValue]="valueProperty" [multiple]="multiple"
    [placeholder]="placeholder" [clearable]="clearable" [formControl]="control" [searchable]="searchable" [closeOnSelect]="!multiple"
    (change)="onChange($event)" (search)="onSearch($event)">

    <ng-template ng-option-tmp let-item="item" let-index="index">
        <img [src]="'data:image/png;base64,' + (item.image || item.Image)" class="option-image"> {{item[labelProperty]}}
    </ng-template>

    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div class="ng-value" *ngFor="let item of items">
            <img [src]="'data:image/png;base64,' + (item.image || item.Image)" class="option-image">
            <span class="ng-value-label">{{item[labelProperty]}}</span>
            <span class="ng-value-icon right" (click)="clear(item)">&#10005;</span>
        </div>
    </ng-template>

    <!-- This is the template for the selected label when not in multiple mode -->
    <ng-template ng-label-tmp let-item="item">
        <img [src]="'data:image/png;base64,' + (item.image || item.Image)" class="option-image">
        <span>{{item[labelProperty]}}</span>
    </ng-template>
</ng-select>

<div *ngIf="control.invalid && (submitted || control.touched)" style="font-size: .875rem; color: #dc3545;">
    <div *ngIf="control.errors?.['required']">{{ errorMessage }}</div>
</div>
<div *ngIf="isMaxLimited" style="font-size: .875rem; color: #dc3545;">
    <div>You can only select up to {{ max }} items.</div>
</div>